module.exports = __webpack_public_path__ + "img/Couple-dependant.384c34ee.svg";